import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: 'en', name: t('language.en'), flag: '🇺🇸' },
    { code: 'es', name: t('language.es'), flag: '🇪🇸' },
    { code: 'fr', name: t('language.fr'), flag: '🇫🇷' },
    { code: 'de', name: t('language.de'), flag: '🇩🇪' },
    { code: 'zh', name: t('language.zh'), flag: '🇨🇳' },
    { code: 'ar', name: t('language.ar'), flag: '🇸🇦' },
    { code: 'pt', name: t('language.pt'), flag: '🇧🇷' },
    { code: 'ru', name: t('language.ru'), flag: '🇷🇺' },
    { code: 'ja', name: t('language.ja'), flag: '🇯🇵' },
    { code: 'ko', name: t('language.ko'), flag: '🇰🇷' }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" style={{ position: 'relative' }}>
      <button
        className="language-button"
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 12px',
          background: 'white',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '14px',
          fontWeight: '500',
          color: '#424242',
          transition: 'all 0.3s ease',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        <span>{currentLanguage.flag}</span>
        <span>{currentLanguage.name}</span>
        <span style={{ 
          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
          transition: 'transform 0.3s ease'
        }}>
          ▼
        </span>
      </button>

      {isOpen && (
        <div
          className="language-dropdown"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '4px',
            background: 'white',
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            zIndex: 1000,
            minWidth: '150px',
            overflow: 'hidden'
          }}
        >
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                width: '100%',
                padding: '12px 16px',
                background: language.code === i18n.language ? '#f5f5f5' : 'transparent',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: language.code === i18n.language ? '600' : '500',
                color: '#424242',
                transition: 'background 0.3s ease',
                textAlign: 'left'
              }}
              onMouseEnter={(e) => {
                if (language.code !== i18n.language) {
                  e.target.style.background = '#f9f9f9';
                }
              }}
              onMouseLeave={(e) => {
                if (language.code !== i18n.language) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              <span>{language.flag}</span>
              <span>{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
